import React, { Component } from "react";
import AgoraRTC from "agora-rtc-sdk-ng";

let client = AgoraRTC.createClient({ mode: "live", codec: "h264" });
const appId = '4b8cf47da479417a8aad4fa77565c725'

export default class Call extends Component {
  state = {
    remoteStreams: {},
    idd: '',
    channel: '',
    localStream: [],
    videoTrack: null,
    audioTrack: null,
  }


  async componentDidMount() {
    const localStream = await AgoraRTC.createMicrophoneAndCameraTracks()
    this.setState({ localStream })
    client.setClientRole("host")
    // faz o join e o publish de audio e video
    this.initOrLeave();
    // console.log("DID MOUNT", USER_ID)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps && prevProps.local === true && this.props.local === false) {
      this.initOrLeave();
    }
  }

  async initOrLeave() {

    // console.log("INIT OR LEAVE", USER_ID)

    if (this.props.local) {
      // console.log("this.props.local", this.props.local, USER_ID)

      await this.joinChannel();
      // adiciona os remotos
      if (this.props.channel != this.state.idd) {
        this.setState({
          idd: this.props.channel
        });
      }

    } else {
      this.setState({ idd: '' });
      this.closeLocalStream();
      this.leaveChannel();
    }
  }

  closeLocalStream = () => {
    this.state.localStream.forEach(s => { s.stop(); s.close() });
    // console.log("CLOSE STREAM", this.props.local, USER_ID)
    this.setState({ idd: '' });
  }

  async publishVideo() {
    const videoTrack = this.state.localStream[1]
    await videoTrack.play("agora_local");
    await client.publish(videoTrack);
  };

  async publishAudio() {
    const audioTrack = this.state.localStream[0]
    await client.publish(audioTrack);
    // await audioTrack.play();
  };

  initLocalStream = async () => {
    await this.publishVideo()
    await this.publishAudio()
    // console.log("INICIOU STREAM -----", USER_ID)
  };

  onUserPublish = async (
    user,
    mediaType
  ) => {
    if (mediaType === "video") {
      const remoteTrack = await client.subscribe(user, mediaType);
      // console.log("remoteTrack------ ", remoteTrack.getUserId());
      remoteTrack.play(`agora_remote`);
      // console.log("play video --- ")
      // setIsVideoSubed(true);
    }
    if (mediaType === "audio") {
      const remoteTrack = await client.subscribe(user, mediaType);
      remoteTrack.play();
      // console.log("play audio --- ")
    }
  };

  onUserUnpublish = async (
    user
  ) => {
    console.log("unpublish ----", user)
    client.leave();
    this.closeLocalStream();
    this.leaveChannel();
    this.props.endCall()
  };

  usersPublished = async (
    users
  ) => {
    console.log(users)
  };

  joinChannel = async () => {

    // console.log("tentou join -----", USER_ID)
    console.log("channel -----", this.props.channel)

    client.on("user-published", this.onUserPublish);
    client.on("user-unpublished", this.onUserUnpublish);
    client.on("published-user-list", this.usersPublished)
    // client.on("user-joined", this.onUserPublish)
    const res = await client.join(
      appId,
      this.props.channel,
      null,
      this.props.videocallUid, // tem q vir null ou undefined aqui pra funcionar 100%, ainda não entendi pq
    );
    // console.log("joined -----", USER_ID, res)
    await this.initLocalStream();
  };

  leaveChannel = () => {
    client.leave();

    this.setState({
      remoteStreams: {},
      channel: ''
    });
  };

  render() {
    return (
      <div>
        {/* {Object.keys(this.state.remoteStreams).sort((a, b) => { return -1; }).map(key => {
          let stream = this.state.remoteStreams[key];
          let streamId = stream.getId();
          return (
            <div>
              <div
                key={streamId}
                id={`agora_remote ${streamId}`}
                style={{ width: '100%', height: '100%', position: "absolute", right: "0px", bottom: "0px", top: '0px', left: '0px' }}

              />
            </div>
          );
        })} */}

        <div
          id={`agora_remote`}
          style={{ width: '100%', height: '100%', position: "absolute", right: "0px", bottom: "0px", top: '0px', left: '0px' }}
        />
      </div>
    );
  }
}